import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { BillingSharedUiModule } from '@amfam/billing/shared/ui';
import { PipesModule } from '@amfam/shared/ui/pipes';
import { BrandDirectivesModule } from '@amfam/shared/utility/brand';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { AutoPayDetailTableComponent } from './auto-pay-detail-table/auto-pay-detail-table.component';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    UiKitModule,
    SharedServicesModule,
    BrandDirectivesModule,
    BillingSharedUiModule,
    NgxDatatableModule
  ],
  exports: [AutoPayDetailTableComponent],
  declarations: [AutoPayDetailTableComponent]
})
export class BillingAutoPayDetailUiModule {}
